// Wyjątek wyświetlania: użytkownik "monika" pokazywany jest jako "Monika".
// Pozostałe nicki bez zmian. Dane w bazie zostają nietknięte — to tylko warstwa UI.
export function displayNick(nick: string): string {
  return nick === 'monika' ? 'Monika' : nick;
}
